export default "__VITE_ASSET__Drol3YBV__"